import React from "react";
import {
  Box,
  Divider,
  FormControl,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
} from "@mui/material";
import { Icon } from "@iconify/react";

const dividerStyle = {
  py: 0,
  my: "2px !important",
  width: "80%",
  borderRadius: 2,
  border: "0.1px solid var(--app-border)",
};

const DropdownIcon = (props) => (
  <Icon icon="eva:arrow-ios-downward-fill" width={18} height={18} {...props} />
);

// Single-select filter styled like the shared Filters/ dropdowns.
function DeviceSelectFilter({ label, value, options, onChange, minWidth = 180 }) {
  const selected = options.find((opt) => opt.value === value);

  return (
    <FormControl size="small">
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={DropdownIcon}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={() => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            <span>{label}:</span>
            <Box
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "var(--app-text)",
              }}
            >
              {selected?.label || "All"}
            </Box>
          </Box>
        )}
        sx={{
          height: 38,
          minWidth,
          borderRadius: "10px",
          backgroundColor: "var(--app-surface)",
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              border: "1px solid var(--app-border)",
              boxShadow: "var(--app-shadow)",
            },
          },
          disableScrollLock: true,
        }}
      >
        {options.map((opt, index) => [
          <MenuItem
            key={opt.value}
            value={opt.value}
            sx={{
              py: 0,
              "&.Mui-selected": { backgroundColor: "transparent" },
              "&.Mui-selected:hover": { backgroundColor: "transparent" },
            }}
          >
            <Radio
              checked={value === opt.value}
              size="small"
              sx={{
                color: "var(--app-border)",
                "&.Mui-checked": { color: "#5751E9" },
              }}
            />
            <ListItemText
              primary={opt.label}
              primaryTypographyProps={{
                fontSize: "14px",
                color: "var(--app-text)",
                fontWeight: 500,
              }}
            />
          </MenuItem>,
          index < options.length - 1 ? (
            <Divider
              key={`${opt.value}-divider`}
              component="li"
              variant="middle"
              sx={dividerStyle}
            />
          ) : null,
        ])}
      </Select>
    </FormControl>
  );
}

export default DeviceSelectFilter;
